/**
 * Simulation clock for gameplay timers (spawns, cooldowns, mode rounds, speedrun lasers).
 * Advances only when the game loop steps simulation — not from wall clock — so matches
 * stay deterministic given the same dt sequence (and framerate-independent when dt-scaled).
 */

/** Gameplay constants assume ~60 Hz; scale per-frame rates with `dt * REFERENCE_HZ`. */
export const REFERENCE_HZ = 60;

/** Cap frame dt so lag spikes cannot teleport entities / skip huge timer chunks. */
export const MAX_FRAME_DT_SEC = 0.05;

let simNowMs = 0;

export function resetGameSimClock(startMs = 0): void {
  simNowMs = Number.isFinite(startMs) ? Math.max(0, startMs) : 0;
}

/** Monotonic simulation time in ms (same role as performance.now() for gameplay timers). */
export function getGameSimNowMs(): number {
  return simNowMs;
}

export function getGameSimNowSec(): number {
  return simNowMs / 1000;
}

export function advanceGameSimClock(dtSec: number): void {
  if (!(dtSec > 0) || !Number.isFinite(dtSec)) return;
  simNowMs += dtSec * 1000;
}

export function clampFrameDtSec(dtSec: number): number {
  if (!(dtSec > 0) || !Number.isFinite(dtSec)) return 0;
  return Math.min(MAX_FRAME_DT_SEC, dtSec);
}
